import React from "react";

import {useGetRedirectToDeviationCreate} from "../../utils/businessLogic/redirectToDeviationCreate";
import { OrderStatusEditField } from "../inputs/OrderStatusEditField";
import { ReferenceEditableField } from "./EditableField";
import { FakeReferenceTextField } from './FakeReferenceTextField';

export const OrderStatusField = ({
	editable,
	permissions,
	text_field_source = "status_name",
	optimized = false,
	additionalParams = [],
	...rest
}) => {
	const redirectToDeviationCreate = useGetRedirectToDeviationCreate();

	return (
		<ReferenceEditableField
			optimized={optimized}
			editable={editable}
			permissions={permissions}
			reference="order-statuses"
			additionalParams={additionalParams}
			onSuccess={redirectToDeviationCreate}
			editField={(rec) => <OrderStatusEditField data={rec} permissions={permissions} />}
			{...rest}
		>
			<FakeReferenceTextField source="status_id" replaceSource={text_field_source} />
		</ReferenceEditableField>
	);
};
